import { render, staticRenderFns } from "./PgaCreateButton.vue?vue&type=template&id=72bb642a&"
import script from "./PgaCreateButton.vue?vue&type=script&lang=ts&"
export * from "./PgaCreateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bb642a')) {
      api.createRecord('72bb642a', component.options)
    } else {
      api.reload('72bb642a', component.options)
    }
    module.hot.accept("./PgaCreateButton.vue?vue&type=template&id=72bb642a&", function () {
      api.rerender('72bb642a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaCreateButton.vue"
export default component.exports